export const PUSH_ERROR = "ERROR/PUSH_ERROR";
export const CLEAR_ERRORS = "ERROR/CLEAR_ERRORS";
